import styled, { css } from 'styled-components';

export const AppPage = styled.div`
  height: inherit;
  width: 100%;
  box-shadow: ${(props) => (props.mode === 'true' ? '0px' : '-10px')} 
  ${(props) => (props.mode === 'true' ? '0px' : '-10px')}
  ${(props) => (props.mode === 'true' ? '0px' : '10px')}
  ${(props) => (props.mode === 'true' ? '0px' : '5px')}
  ${(props) => props.settings.common.containerShadowColor};
  display: flex;
  flex-direction: column;
  flex: 1 0 auto !important;

    overflow: hidden;
    padding-bottom: 4px;

    .content {
        flex: 1;
        width: 100%;
        z-index: 1;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        .title {
            font-size: 1.2rem;
            line-height: 1.5rem;
            font-weight: normal;

            padding: 1rem 2rem;
            padding-top: 0.9rem;
            ${props => props.pluginMode === 'true' && css`
                padding-bottom: 0.5rem;
            `}

            padding: 0 40px !important;
            img {
                height: 1.25rem;
            }
        }
        
        .plugin-header{
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 87px;
              background: ${props => props.pluginMode === 'true' ? '#F1F1F1' :''};
              border-radius: 7px 7px 0px 0px;
        }

        .sub-title {
            font-size: 0.8rem;
            line-height: 1rem;

            font-weight: lighter;
            padding-left: 40px;
            padding-right: 40px;
            img {
                height: 1rem;
            }
        }

        .content-footer {
            width: 100%;
            
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            padding-bottom: 1rem;
            ${props => props.pluginMode === 'true' && css`
            padding-bottom: 1rem;
            `}
        }
    }

    .buttons {
        height: 3rem;
        width: 100%;
        
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        
        margin: 0;

        span {
            height: 3rem;
            margin: 0 1.5rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
    }
`;

export const PreFooter = styled.div`
    z-index: 1;
    max-height: 5rem;
`;

export default AppPage;
